import React from "react";
import {  ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Checkbox } from "../ui/checkbox";
import { cn } from "../ui/utils";

const MultiSelectWithCheckbox = ({
  value = [],
  onChange,
  options = [],
  placeholder = "Select options",
  className,
  disabled = false,
}) => {
  const toggleOption = (val) => {
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
  };

  const selectedLabels = options
    ?.filter((opt) => value.includes(opt.value))
    ?.map((opt) => opt.label)
    ?.join(", ");

  return (
    <Popover>
      <PopoverTrigger
        asChild
        disabled={disabled}
      >
        <button
          type="button"
          className={cn(
            " dark:text-white flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
        >
          <span className={cn(
              "truncate text-left",
              !selectedLabels && "text-muted-foreground dark:text-white"
            )}>
            {selectedLabels || placeholder}
          </span>
          <ChevronDown className="h-4 w-4 opacity-50 ml-8" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-full w-[var(--radix-popover-trigger-width)] max-h-60 overflow-y-auto p-4  dark:bg-gray-800 rounded-md shadow-md">
        {options?.map(({ label, value: val, disabled: optDisabled }) => (
          <div
            key={val}
            className={cn(
              "flex items-center px-2 py-2 rounded-sm cursor-pointer hover:bg-accent dark:hover:bg-gray-700",
              optDisabled && "opacity-50 cursor-not-allowed"
            )}
            onClick={() => {
              if (!optDisabled) toggleOption(val);
            }}
          >
            <Checkbox
              className="mr-8"
              style={{borderColor:"#cbd5e1"}}
              checked={value.includes(val)}
              onCheckedChange={() => toggleOption(val)}
              disabled={optDisabled}
            />
            <span className="text-sm text-gray-900 dark:text-white">{label}</span>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default MultiSelectWithCheckbox;
